module.exports = __webpack_public_path__ + "static/media/rp04.b3237306.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/PopYoanovaPrepravka/assets/rp04.jpg
// module id = 215
// module chunks = 0